import { Spacing } from '@persona-id/design-tokens';
import { useState } from 'react';
import styled from 'styled-components';

import {
  DashboardPageLink,
  UnorderedList,
} from 'dashboard/views/DashboardSandboxHomeView/constants';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface InviteTeamMembersStepProps {
  isStepCompleted: boolean;
  isLoadingUsers: boolean;
  handleLoadUsers: () => Promise<void>;
}

const InviteTeamMembersStep = ({
  isStepCompleted,
  isLoadingUsers,
  handleLoadUsers,
}: InviteTeamMembersStepProps) => {
  const [isStepStatusRefreshed, setIsStepStatusRefreshed] = useState(false);

  return (
    <>
      <Paragraph color='primary'>
        You may want to tap into different types of expertise as you set up Persona. Key
        responsibilities that might be spread out across team members include:
      </Paragraph>
      <Spacer height={2} />
      <UnorderedList>
        <li>Fraud and risk management</li>
        <li>Product, design, and user experience</li>
        <li>Engineering (specific software teams for web versus mobile)</li>
      </UnorderedList>
      <Spacer height={2} />
      <Paragraph color='primary'>
        Set yourself up for success. Invite team members to Persona so they can help think through,
        design, and configure the best way to integrate your solution.
      </Paragraph>
      <Spacer height={2} />
      <ButtonRow>
        <Button
          id='home-sandbox-onboarding-checklist__invite-team-members'
          width='button'
          onClick={() => window.open(DashboardPageLink.Users)}
        >
          {isStepCompleted ? 'Invite more team members' : 'Invite team members'}
        </Button>
        {!isStepCompleted && (
          <Button
            id='home-sandbox-onboarding-checklist__refresh-users-list'
            disabled={isLoadingUsers}
            variant='basic'
            width='button'
            onClick={() => {
              handleLoadUsers();
              setIsStepStatusRefreshed(true);
            }}
          >
            Mark step completed
          </Button>
        )}
      </ButtonRow>
      {isStepStatusRefreshed && !isStepCompleted && (
        <>
          <Spacer height={2} />
          <Paragraph color='secondary'>
            Looks like you haven’t invited any team members yet!
          </Paragraph>
        </>
      )}
    </>
  );
};

const ButtonRow = styled('div')`
  display: flex;
  flex-direction: row;
  column-gap: ${Spacing[2]};
`;

export default InviteTeamMembersStep;
